import React, { useState } from "react";
import "./GlobalPostButton.css";
import PostDialog from "./GlobalPostDialog";

const GlobalPostButton = ({ onNewPost }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openPostDialog = () => {
    document.body.classList.add("modal-open");
    setIsDialogOpen(true);
  };

  const closePostDialog = () => {
    document.body.classList.remove("modal-open");
    setIsDialogOpen(false);
  };

  const handlePostSubmit = async (content, media, gif) => {
    try {
      const currentUser = localStorage.getItem("currentUser")
        ? JSON.parse(localStorage.getItem("currentUser")).username
        : null;

      const bodyData = {
        content,
        username: currentUser,
        gif,
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL}/posts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) throw new Error("Failed to submit post.");

      const newPost = await response.json();

      if (typeof onNewPost === "function") {
        onNewPost(newPost);
      }

      closePostDialog();
    } catch (error) {
      console.error("Error submitting post:", error);
      alert("Failed to submit post.");
    }
  };

  return (
    <>
      <button className="global-post-button" onClick={openPostDialog}>
        <span className="icon">+</span> Post
      </button>
      <PostDialog
        isOpen={isDialogOpen}
        onClose={closePostDialog}
        onSubmit={handlePostSubmit}
      />
    </>
  );
};

export default GlobalPostButton;
